import React from 'react';
import './FinalizacaoOportunidadePage.css';
import MaterialIcon from "material-icons-react";
import { encode as base64_encode } from 'base-64';
import { retornarCookie } from '../../services/cookieservice';
import { ConfigurarSas } from "../../components/GatewaySas/GatewaySas";
import { Button } from "react-materialize";
import axios from "axios";
import Loader from './../../components/Loader/Loader';

const { REACT_APP_API, REACT_APP_URL_INSTANCE } = process.env;

export default class FinalizacaoOportunidadePage extends React.Component {
    state = {
        autoRedirect: true,
        countdown: 30,
        exibeProcessando: true,
        listaOportunidades: undefined,
        listaOportunidadeRefreshRate: 60,
        OportunidadeID: undefined,
        OportunidadeGerada: undefined,
        exibeCarregamento: true,
    };

    countdownInterval;

    componentDidMount() {
        this.setState({ exibeCarregamento: true });

        const urlParams = new URLSearchParams(window.location.search);
        const OportunidadeID = urlParams.get("OportunidadeID");

        this.setState({ OportunidadeID });

        this.CarregarListaOportunidades(OportunidadeID);

        this.refreshInterval = setInterval(() => {
            this.CarregarListaOportunidades(OportunidadeID);
        }, this.state.listaOportunidadeRefreshRate * 1000);
    }


    RemoverProposta = (OportunidadeId) => {
        this.setState({ exibeCarregamento: true });
        if (
            window.confirm("Tem certeza que deseja cancelar esta oportunidade?") ==
            true
        ) {
            axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
            axios
                .put(`${REACT_APP_API}oportunidade/Delete/${OportunidadeId}`)
                .then((res) => {
                    window.location.reload();
                });
        } else {
            window.location.reload();
        }
    };

    RedirecionarProposta = (urlProposta) => {
        window.open(urlProposta, "_blank");
    };


    AprovarProposta = (PropostaId) => {
        if (
            window.confirm(
                "Tem certeza que deseja aprovar a proposta " + PropostaId + "?"
            )
        )
            this.decisaoProposta(PropostaId, true);

    };

    RecusarProposta = (PropostaId) => {
        if (window.confirm("Tem certeza que deseja recusar a oportunidade ?"))
            this.decisaoProposta(PropostaId, false);
    };

    CopiarProposta = async (OportunidadeId) => {
        const redirectTo = base64_encode("NavigationBar,DadosEmpresaPage");

        document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
            retornarCookie("Auth")
        )}&MultiProposta=${OportunidadeId}`;
    };

    decisaoProposta = async (propostaId, decisao) => {
        const requestOptions = {
            method: "POST",
            redirect: "follow",
            mode: "no-cors",
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        };

        return await fetch(
            `${REACT_APP_API}CotacaoPME/ImpressaoProposta?IdProposta=${propostaId}&Decisao=${decisao}`,
            requestOptions
        ).then((result) => {
            window.location.reload();
            return result;
        });
    };
    verificarOportunidade = (oportunidadeID) => {
        if (this.state.listaOportunidades) {
            const oportunidadeEncontrada = this.state.listaOportunidades.find((oportunidade) => {
                return (
                    oportunidade.OportunidadeID.toString() === oportunidadeID &&
                    oportunidade.UrlPDFProposta &&
                    !oportunidade.CotacaoDataAceite &&
                    !oportunidade.CotacaoDataRecusado
                );
            });

            if (oportunidadeEncontrada) {
                this.setState({ exibeProcessando: false });
                this.setState({ OportunidadeGerada: oportunidadeEncontrada });
            } else {
                const oportunidadePerdidaOuGanha = this.state.listaOportunidades.find((oportunidade) => {
                    return (
                        oportunidade.OportunidadeID.toString() === oportunidadeID &&
                        (oportunidade.CotacaoDataAceite || oportunidade.CotacaoDataRecusado)
                    );
                });

                if (oportunidadePerdidaOuGanha) {
                    this.setState({ exibeProcessando: false });
                    this.setState({ OportunidadeGerada: oportunidadePerdidaOuGanha });
                }
            }
        }
    };

    CarregarListaOportunidades = async (oportunidadeID) => {
        ConfigurarSas().then((sessionId) => {
            axios
                .get(
                    `${REACT_APP_API}oportunidade?IdAgenteVendas=` +
                    retornarCookie("IdAgenteVenda")
                )
                .then((res) => {
                    const listaOportunidades = res.data;
                    this.setState({ listaOportunidades });
                    this.verificarOportunidade(oportunidadeID);
                    if (this.state.autoRedirect) {
                        this.startCountdown();
                    }
                    this.setState({ exibeCarregamento: false });
                });
        });
    };

    startCountdown = () => {
        this.countdownInterval = setInterval(() => {
            if (this.state.countdown === 0) {
                clearInterval(this.countdownInterval);
                this.redirectToHomePage();
            } else {
                this.setState((prevState) => ({
                    countdown: prevState.countdown - 1,
                }));
            }
        }, 1000);
    };


    formatarStatus = (status) => {
        const estados = {
            0: "Cadastro",
            1: "Negociacao",
            3: "Ganha",
            4: "Implantada",
            5: "Perdida",
        };
        const estadoString = estados[parseInt(status)];
        return estadoString || status;
    };


    redirectToHomePage = () => {
        const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode('NavigationBar,HomePage')}`;
        const auth = `&Auth=${base64_encode(retornarCookie('Auth'))}`;

        document.location.href = `${redirectTo}${auth}`;
    };


    formatarData = (data) => {
        const date = new Date(data);
        const output = date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        return output;
    };

    formatarCNPJ = (cnpj) => {
        cnpj = cnpj.replace(/[.\-/]/g, "").toUpperCase();
        return cnpj.replace(
            /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})$/,
            "$1.$2.$3/$4-$5"
        );
    };

    cancelAutoRedirect = () => {
        clearInterval(this.countdownInterval);
        this.setState({ autoRedirect: false });
    };

    render() {
        return (
            <div className="fade-in">
                {this.state.exibeCarregamento && <Loader />}

                {this.state.listaOportunidades &&
                    <div className='row container center'>

                        {this.state.OportunidadeGerada && (
                            <div className='OportunidadeGeradaIcon'>
                                <MaterialIcon icon="done_all" />
                            </div>
                        )}

                        {!this.state.OportunidadeGerada && (
                            <div className='OportunidadeGeradaIcon'>
                                <MaterialIcon icon="access_time" />
                            </div>
                        )}

                        <div className='OportunidadeGeradaTitle'>
                            {this.state.OportunidadeGerada ? "Proposta criada com Sucesso!" : 'Estamos quase lá...'}
                        </div>

                        {this.state.OportunidadeGerada && (
                            <div><span className='statusPropostaGerada'>{this.formatarStatus(this.state.OportunidadeGerada.Status)}</span>
                                <div className='PropostaGeradaBar row'>
                                    {/* {this.state.OportunidadeGerada ? this.state.OportunidadeGerada.RazaoSocial : 'teste'} */}

                                    <div className='col s3 center-align'>
                                        <div className='OportunidadeGridAlign'>
                                            Oportunidade ID : {this.state.OportunidadeGerada.OportunidadeID}
                                            <br />
                                            Proposta: <b>{this.state.OportunidadeGerada.PropostaId}</b><verticalhr />
                                        </div>
                                    </div>

                                    <div className='col s3 center-align'>
                                        <div className='OportunidadeGridAlign'>
                                            CNPJ : {this.formatarCNPJ(this.state.OportunidadeGerada.Cnpj)}
                                            <br />
                                            Nome: {this.state.OportunidadeGerada.RazaoSocial}
                                        </div>
                                    </div>

                                    <div className='col s3 center-align'>
                                        <div className='OportunidadeGridAlign'>
                                            Data de Criação : {this.formatarData(this.state.OportunidadeGerada.DataCriacao)}
                                        </div>
                                    </div>

                                    <div className='col s3 center-align'>

                                        {this.state.OportunidadeGerada.UrlPDFProposta && (
                                            <b>
                                                <Button
                                                    node="button"
                                                    tooltip="Copiar Proposta"
                                                    tooltipOptions={{ position: "top" }}
                                                    className="gridIcon"
                                                    onClick={() => {
                                                        this.CopiarProposta(this.state.OportunidadeGerada.OportunidadeID);
                                                    }}
                                                >
                                                    <MaterialIcon icon="content_copy" color="#172972" />
                                                </Button>
                                            </b>
                                        )}

                                        {this.state.OportunidadeGerada.UrlPDFProposta && (
                                            <b>
                                                <Button
                                                    node="button"
                                                    tooltip="Visualizar"
                                                    tooltipOptions={{ position: "top" }}
                                                    className="gridIcon"
                                                    onClick={() => {
                                                        this.RedirecionarProposta(
                                                            this.state.OportunidadeGerada.UrlPDFProposta
                                                        );
                                                    }}
                                                >
                                                    <MaterialIcon icon="remove_red_eye" color="#172972" />
                                                </Button>
                                            </b>
                                        )}
                                        {this.state.OportunidadeGerada.Status !== 1 &&
                                            !this.state.OportunidadeGerada.PropostaGerada && (
                                                <b>
                                                    <Button
                                                        node="button"
                                                        tooltip="Remover"
                                                        tooltipOptions={{ position: "top" }}
                                                        className="gridIcon"
                                                        onClick={() => {
                                                            this.RemoverProposta(this.state.OportunidadeGerada.OportunidadeID);
                                                        }}
                                                    >
                                                        <MaterialIcon icon="delete_forever" color="red" />
                                                    </Button>
                                                </b>
                                            )}
                                        {this.state.OportunidadeGerada.UrlPDFProposta &&
                                            !this.state.OportunidadeGerada.CotacaoDataAceite &&
                                            !this.state.OportunidadeGerada.CotacaoDataRecusado && (
                                                <b>
                                                    <Button
                                                        node="button"
                                                        tooltip="Aprovar"
                                                        tooltipOptions={{ position: "top" }}
                                                        className="gridIcon"
                                                        onClick={() => {
                                                            this.AprovarProposta(this.state.OportunidadeGerada.PropostaId);
                                                        }}
                                                    >
                                                        <MaterialIcon icon="thumb_up" color="#0fbf0f" />
                                                    </Button>
                                                </b>
                                            )}
                                        {this.state.OportunidadeGerada.UrlPDFProposta &&
                                            !this.state.OportunidadeGerada.CotacaoDataAceite &&
                                            !this.state.OportunidadeGerada.CotacaoDataRecusado && (
                                                <b>
                                                    <Button
                                                        node="button"
                                                        tooltip="Recusar"
                                                        tooltipOptions={{ position: "top" }}
                                                        className="gridIcon"
                                                        onClick={() => {
                                                            this.RecusarProposta(this.state.OportunidadeGerada.PropostaId);
                                                        }}
                                                    >
                                                        <MaterialIcon icon="thumb_down" color="red" />
                                                    </Button>
                                                </b>
                                            )}

                                    </div>
                                </div>

                                <div className='col s12 right-align'>
                                    <span className='RetornarHomePageLink' onClick={() => {this.redirectToHomePage()}}>
                                        Voltar para página inicial
                                    </span>
                                </div></div>

                        )}
                        {this.state.exibeProcessando && <>

                            <div className='OportunidadeGeradaSubTitle'>
                                Aguarde enquanto estamos processando todas as informações.
                            </div>

                            <div className="GerandoPropostaLoader">
                            </div>

                            <div className='OportunidadeGeradaOrientacao'>
                                As informações da proposta serão exibidas assim que a proposta for gerada, você pode retornar à página inicial a qualquer momento sem perder o seu progresso.
                            </div>
                        </>}

                        {this.state.autoRedirect && (
                            <div className='fade-in RedirectMessageTimer' onClick={this.cancelAutoRedirect}>
                                Você será redirecionado para a página inicial em
                                <span id='OportunidadeAutoRedirectCounter'>
                                    {this.state.countdown}
                                </span>
                                segundos. <br />(Clique aqui para permanecer na página e acompanhar a evolução da oportunidade)
                            </div>
                        )}

                    </div>}

            </div>
        );
    }
}